import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { css } from "styled-components";

export interface EllipsisVerticalIconStyles {
    ellipsisVerticalIcon?: InjectableCss;
}

export const ellipsisVerticalIconStyles: EllipsisVerticalIconStyles = {
    ellipsisVerticalIcon: {
        css: css`
            display: flex;
            & path {
                fill: ${COLORS.black};
            }
            & svg {
                height: 18px !important;
            }
        `,
    },
};

const styles = ellipsisVerticalIconStyles;

const EllipsisVerticalIcon: React.FC = () => {
    return (
        <StyledWrapper {...styles.ellipsisVerticalIcon}>
            <svg width="4" height="16" viewBox="0 0 4 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.875 2.375C3.875 1.33818 3.03652 0.5 2 0.5C0.963477 0.5 0.125 1.33818 0.125 2.375C0.125 3.41182 0.963477 4.25 2 4.25C3.03652 4.25 3.875 3.41182 3.875 2.375ZM3.875 8C3.875 6.96318 3.03652 6.125 2 6.125C0.963477 6.125 0.125 6.96289 0.125 8C0.125 9.03711 0.963477 9.875 2 9.875C3.03652 9.875 3.875 9.03711 3.875 8ZM3.875 13.625C3.875 12.5882 3.03652 11.75 2 11.75C0.963477 11.75 0.125 12.5882 0.125 13.625C0.125 14.6618 0.963477 15.5 2 15.5C3.03652 15.5 3.875 14.6621 3.875 13.625Z" fill="#262525"/>
            </svg>
        </StyledWrapper>
    );
};

export default React.memo(EllipsisVerticalIcon);
